module.exports = __webpack_public_path__ + "assets/images/albom7.aedea915.jpg";